import {
    ExtendsFieldId,
    ExtendsFieldValidationType,
    ExtendsOrderNum,
    ExtendsUserName,
} from '../types/generics';

/**
 * sortByFieldIdAscending
 *
 * @description
 * Using Array.prototype.sort, sorts ExtendsFieldId objects by their fieldId value,
 * smalled to largest.
 *
 * @param fieldA
 * @param fieldB
 */
export const sortByFieldIdAscending = <T extends ExtendsFieldId>(fieldA: T, fieldB: T): number =>
    fieldA.fieldId > fieldB.fieldId ? 1 : -1;

/**
 * sortByOrderNumAscending
 *
 * @description
 * Using Array.prototype.sort, sorts ExtendsOrderNum objects by their orderNum value,
 * smalled to largest.
 *
 * @param fieldA
 * @param fieldB
 */
export const sortByOrderNumAscending = <T extends ExtendsOrderNum>(fieldA: T, fieldB: T): number =>
    fieldA.orderNum > fieldB.orderNum ? 1 : -1;

export const sortByValidationType = <T extends ExtendsFieldValidationType>(a: T, b: T): number => {
    return a.validationType > b.validationType ? 1 : -1;
};

export const sortByUsername = <T extends ExtendsUserName>(a: T, b: T): number => {
    const nameA = a.userName.toLowerCase(),
        nameB = b.userName.toLowerCase();
    if (nameA < nameB)
        //sort string ascending
        return -1;
    if (nameA > nameB) return 1;
    return 0; //default return value (no sorting)
};
